/* eslint @typescript-eslint/no-unused-vars: 0 */
import React from 'react'

import LogoDarkSvg from '../../../assets/svg/logo-dark.svg'
import HomeSvg from '../../../assets/svg/home.svg'

import {
  Container,
  Logo,
  Clipart,
} from './styles'

const Home = () => (
  <Container>
    <Logo src={LogoDarkSvg} alt="Fingermenu" />

    <Clipart src={HomeSvg} alt=" " />
  </Container>
)

export default Home
